import { render, staticRenderFns } from "./FormEmailEditor.vue?vue&type=template&id=60181c01"
import script from "./FormEmailEditor.vue?vue&type=script&lang=js"
export * from "./FormEmailEditor.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports